<template>
    <div>
        <div v-if="seeReport">
            <vs-row>
                <vs-col vs-xs="6" vs-sm="3" vs-lg="2">
                    <InputSelect
                        :model.sync="month"
                        placeholder="Select Month"
                        container_class="w-auto input-custom-dropdown my-3"
                        :multiple="false"
                        :options="month_options"
                    />
                </vs-col>
                <vs-col vs-xs="6" vs-sm="3" vs-lg="2">
                    <InputSelect
                        :model.sync="year"
                        placeholder="Select Year"
                        container_class="w-auto input-custom-dropdown my-3"
                        :multiple="false"
                        :options="year_options"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="4">
                    <InputSelect 
                        :model.sync="package_"
                        placeholder="Select Package"
                        container_class="w-full my-3 mb-3"
                        :options="package_options"
                    />
                </vs-col>

                <vs-col vs-xs="12" vs-sm="6" vs-lg="4">
                    <InputSelect 
                        :model.sync="status"
                        placeholder="Select Status"
                        container_class="w-full my-3 mb-3"
                        :options="status_options"
                    />
                </vs-col>
            </vs-row>
    
            <template v-if="loading">
                <vx-card>
                    <h3>Loading Data.. Please wait..</h3>
                </vx-card>
            </template>
    
            <template v-else>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <h4 class="" v-if="report">{{ report.name }} (Billing Report)</h4>
                    <vx-tooltip text="Create Excel" color="primary" class="ml-2">
                        <vs-button size="small" color="primary" type="filled" @click="create_excel"  class="ml-2" :disabled="loading">
                            <font-awesome-icon :icon="excel" />
                        </vs-button>
                    </vx-tooltip>
                </div>
    
                <template v-if="ongoing_exports.length">
                    <vs-alert color="primary" v-if="loading_exports">
                        Loading Latest Exports, please wait..
                    </vs-alert>
                    <template v-else>
                        <template v-for="(item, index) in ongoing_exports">
                            <vs-alert color="primary" :key="index" class="mb-2">
                                <template v-if="item.status == 'p'">
                                    Your export is pending, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 's'">
                                    Your export is in queue, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 'r'">
                                    Your export is being generated, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 'c'">
                                    Your export has been completed. (<FormatText :text="item.created_on" format="datetime" />) ({{ item.params.schedule_name }}/{{ item.params.package_name }}) <a :href="item.export_excel" target="_blank" style="float:right;"><vs-button size="small">Download</vs-button></a>
                                </template>
                                <template v-else-if="item.status == 'f'">
                                    Your export has been failed, please request again!
                                </template>
                            </vs-alert>
                        </template>
                    </template>
                </template>
    
                <vs-row>
                    <vs-col>
                        <vs-table class="freeze_row row1" hoverFlat :data="package_keys" noDataText="No Parameters defined for this package" >
                            
                            <template slot="thead">
                                <vs-th style="min-width: 50px;">BOQ</vs-th>
                                <vs-th style="min-width: 190px;">Description of Work</vs-th>
                                <vs-th style="min-width: 80px;">UOM</vs-th>
                                <vs-th style="min-width: 120px;" class="text-center">Qty as per BOQ</vs-th>
                                <vs-th style="min-width: 120px;">Freq.</vs-th>
                                <vs-th style="min-width: 150px;">Total Qty as per Freq.</vs-th>
                                <vs-th style="min-width: 100px;">Weightage %</vs-th>
                                <vs-th style="min-width: 150px;">Current Months Quantity</vs-th>
                                <vs-th style="min-width: 140px;">Upto Last Month Quantity</vs-th>
                                <vs-th style="min-width: 120px;">Cumulative Quantity</vs-th>
                                <vs-th style="min-width: 120px;">Unit Rate(Rs)</vs-th>
                                <vs-th style="min-width: 120px;">Total Amount(Rs)</vs-th>
                                <vs-th style="min-width: 140px;">Remarks</vs-th>
                            </template>
    
                            <vs-tr v-for="(report_key, index) in package_keys" :key="index" :data="index" :disabled="report_key.is_heading">
                                <vs-td :class="{'font-bold': report_key.is_heading}">
                                    {{ report_key.boq_no.replace(report_key.parent_key ? `${report_key.parent_key.boq_no}.` : "", "") }}
                                </vs-td>
                                <vs-td :class="{'font-bold': report_key.is_heading}">
                                    {{ report_key.description }}
                                </vs-td>
                                <template v-if="report_key.is_heading">
                                    <vs-td colspan="11"></vs-td>
                                </template>
                                <template v-else>
                                    <template v-if="Object.keys(data).length">
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].params['unit_of_measurement']) ? Number(data[get_key(report_key.id)].params['unit_of_measurement']).toFixed(2) : data[get_key(report_key.id)].params['unit_of_measurement'] }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].target_value).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ data[get_key(report_key.id)].params['frequency'] || "0" }} times per <FormatText :text="data[get_key(report_key.id)].params['frequency_unit']" format="select" :kwargs="frequency_options" />
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].target_value * (data[get_key(report_key.id)].params['frequency'] || 0)).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].params['weightage']).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].current_value).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].upto_last_month_quantity).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number((data[get_key(report_key.id)].current_value || 0) + (data[get_key(report_key.id)].upto_last_month_quantity || 0)).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number(data[get_key(report_key.id)].params['unit_rate']).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ Number((data[get_key(report_key.id)].params['unit_rate'] || 0) * ((data[get_key(report_key.id)].current_value || 0))).toFixed(2) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ data[get_key(report_key.id)].remarks }}
                                        </vs-td>
                                    </template>
                                    <template v-else>
                                        <vs-td colspan="11"></vs-td>
                                    </template>
                                </template>
                            </vs-tr>
                        </vs-table>
                    </vs-col>
                </vs-row>
            </template>
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>

<script>
import { faPlus, faClock, faCheckCircle, faTimesCircle, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../../utils/requests';
import moment from 'moment';

export default {
    props: {
        report_mode: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {

            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            data: {},

            packages: [],

            package_: null,
            package_keys: [],

            status: null,

            selected_rows: [],
            api_errors: {},

            loading_modules: {
                packages: false,
                package_keys: false,
                package_data: false
            },
            month_options: [
                {value: 1, label: "Jan"},
                {value: 2, label: "Feb"},
                {value: 3, label: "Mar"},
                {value: 4, label: "Apr"},
                {value: 5, label: "May"},
                {value: 6, label: "Jun"},
                {value: 7, label: "Jul"},
                {value: 8, label: "Aug"},
                {value: 9, label: "Sep"},
                {value: 10, label: "Oct"},
                {value: 11, label: "Nov"},
                {value: 12, label: "Dec"},
            ],
            
            status_options: [
                {value: 'pending', label: "Pending"},
                {value: 'approved', label: "Approved"},
            ],

            frequency_options: [
                {value: 'day', label: "Day"},
                {value: 'month', label: "Month"},
                {value: 'week', label: "Week"},
                {value: 'year', label: "Year"},
            ],

            loading_exports: false,
            ongoing_exports: []

        }
    },
    computed: {
        addIcon: () => faPlus,
        pending: () => faClock,
        approved: () => faCheckCircle,
        rejected: () => faTimesCircle,
        excel: () => faFileExcel,
        year_options: () => {
            let years = []
            for (let i=new Date().getFullYear(); i>=1990; i--) {
                years.push({value: i, label: i.toString()})
            }

            return years
        },
        package_options() {
            return this.packages.map(v => {
                return {
                    value: v.id,
                    label: v.name
                }
            })
        },
        loading() {
            return Object.keys(this.loading_modules).filter(v => this.loading_modules[v] == true).length > 0
        },
        report() {
            let matches = this.$store.state.organisation.dpr_reports.filter(v => v.id == this.$route.params.report_id)
            if (matches.length) return matches[0]
            else return null
        },
        seeReport() {
            return this.hasAccess('read', `dpr_log_billing_report`, 'all')
        }
    },
    watch: {
        month (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        year (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        package_ (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        status (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        '$route.params.report_id' (newV, oldV) {
            if (newV == oldV) return
            this.init()
            this.refresh_exports()
        }
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        if (this.export_timer) clearTimeout(this.export_timer)
    },
    methods: {
        init() {
            this.load_packages()
        },
        load_packages() {
            this.loading_modules.packages = true
            Request(this, 'GET', this.$store.state.apiendpoints.dpr_packages, {report: this.$route.params.report_id, limit: 100}).then(
                res => {
                    this.packages = res.results
                    this.loading_modules.packages = false
                    
                    if (this.packages.length)
                        this.package_ = this.packages[0].id
                },
                err => {
                    this.loading_modules.packages = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available packages! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_data() {
            this.load_dpr_keys()
            this.load_dpr_data()
        },
        load_dpr_keys() {
            this.loading_modules.package_keys = true
            let url = `${this.$store.state.apiendpoints.dpr_package_keys}`

            let payload = {
                package: this.package_,
                limit: 100
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_keys = false
                    this.package_keys = res.results
                },
                err => {
                    this.loading_modules.package_keys = false
                    this.package_keys = []
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available report parameters! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_dpr_data() {
            this.loading_modules.package_data = true

            let url = `${this.$store.state.apiendpoints.dpr_month}`
            let payload = {
                month: this.month,
                year: this.year,
                package: this.package_,
                report_mode: true,
                is_billing_report: true,
                status: this.status,
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_data = false
                    this.data = res
                    this.refresh_exports()
                },
                err => {
                    this.loading_modules.package_data = false
                    this.data = {}
                }
            )
        },
        get_key(key) {
            if (!this.data[key]) {
                this.$set(this.data, key, {
                    params: this.package_keys.filter(obj => obj.id == key).length ? this.package_keys.filter(obj => obj.id == key)[0].default_month_params : {
                        frequency: null,
                        frequency_unit: null,
                        weightage: null,
                        unit_of_measurement: null,
                        unit_rate: null,
                        mandatory: null
                    },
                    remarks: null,
                    status: 'p',
                    target_value: 0,
                    current_value: 0
                })

            } else if(this.data[key] && !this.data[key]['params']) {
                this.$set(this.data, key, {
                    ...this.data[key],
                    params: this.package_keys.filter(obj => obj.id == key).length ? this.package_keys.filter(obj => obj.id == key)[0].default_month_params : {
                        frequency: null,
                        frequency_unit: null,
                        weightage: null,
                        unit_of_measurement: null,
                        unit_rate: null,
                        mandatory: null
                    },
                })
            }
            
            return key
        },
        create_excel() {

            this.$vs.loading();

            let payload = {
                module_key: 'd',
                params: {
                    "issue_type": this.$route.params.issue_type,
                    "status": this.status,
                    "rm_type": 'billing',
                    "filters": {},
                    'package': this.package_,
                    'schedule_name': this.report.name,
                    'package_name': this.package_options.filter(v => v.value == this.package_)[0].label,
                    'month': this.month,
                    'year': this.year
                }
            }

            let url = this.$store.state.apiendpoints.excel_create

            Request(this, 'POST', url, null, payload).then( 
                (res) => {

                    this.$vs.loading.close();
                    this.refresh_exports()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Success',
                        text: "Your request to download file has been submitted",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                }, 
                (err) => {

                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        refresh_exports() {
            this.loading_exports = true

            let url = this.$store.state.apiendpoints.excel_list

            let payload = {
                created_on: moment().format('YYYY-MM-DD'),
                module_key: 'd',
                params__issue_type: this.$route.params.issue_type,
                params__rm_type: 'billing',
                params__schedule_name: this.report.name,
                params__package_name: this.package_options.filter(v => v.value == this.package_)[0].label,
                limit: 4
            }

            Request(this, 'GET', url, payload).then( 
                (res) => {
                    this.ongoing_exports = res.results
                    this.loading_exports = false
                    if(this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
                }, 
                (err) => {
                    this.loading_exports = false;
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Unable to load current exports, please refresh to try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        auto_refresh_export() {
            this.export_timer = setTimeout(() => {
                this.refresh_exports()
            }, 5000);
        },
    }
}
</script>
